import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import axios from 'axios';
import authService from '../services/authService';
import Header from './Header';
import Sidebar from './Sidebar';
import '../App.css';

const Layout = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      const s = window.scrollY > 4;
      setScrolled(prev => (prev !== s ? s : prev));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // On mount: verify token with a lightweight protected call (auth middleware will 401 if invalid)
  useEffect(() => {
    const user = authService.getCurrentUser();
    if(!user?.token) return; // Already handled by PrivateRoute
    let cancelled = false;
    (async () => {
      try {
        await axios.get('/api/auth/', { headers: { 'x-auth-token': user.token }});
      } catch (e) {
        if(cancelled) return;
        authService.logout();
        navigate('/login', { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="app-layout">
      <div className={"app-header" + (scrolled ? ' scrolled' : '')}>
        <Header />
      </div>
      <div className="app-body">
        <Sidebar />
        <main className="app-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;